export default __webpack_public_path__ + "static/media/LocalGodIcon.39340066.png";